import { STATUS } from 'utils/constants'
import React from 'react'
import './style.scss'

interface BigCircleBtnProps {
  text?: string
  disabled?: boolean
  interior?: JSX.Element
  status?: response.StatusTypes
  action: React.MouseEventHandler<HTMLDivElement>
}

const BigCircleBtn: React.FC<BigCircleBtnProps> = ({ interior, disabled, text = '', status = STATUS.idle, action }) => {
  return (
    <div
      key={text}
      className={`button__circle --big --secFont${disabled ? ' --disabled' : ''}`}
      onClick={action}>
      {status === STATUS.pending && <div className='button__ring --rotated' />}
      {status === STATUS.succeed && <div className='button__ring' />}
      {interior || <span>{text}</span>}
    </div>
  )
}

export default BigCircleBtn